<template>
    <div class="d-flex flex-column" id="wrap_pending_products">
        <v-overlay :value="isLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <div v-if="inDialog" ref="dialogHeader">
            <v-row v-if="message !== ''">
                <v-col md="12" class="pt-1">
                    <div class="px-3 py-3 font-size-sm blocked-background dark-red-color" style="border-radius: 16px !important" v-html="tHtml(message)"></div>
                </v-col>
            </v-row>
        </div>

        <v-row v-if="!inDialog" ref="headerFilters">
            <data-table-filters  v-if="!isMobile"
                name="Produtos Pendentes"
                :has-active-filters="hasActiveFilters"
                :has-expanded-active-filters="hasExpandedActiveFilters"
                :filters="filters"
                :schema="tSchema(schema)"
                @expand-active-filters="hasExpandedActiveFilters = $event"
                @remove-filter="removeFilter"
                @refresh="refresh"
                @clear-filters="onClearFilters()"
                :showMessage="true"
                :messageUrl="'/api/orders/pending-products-alert'"
            >
            </data-table-filters>
            <div class="col wrap-title-filters" v-else >
             <filters-dialog
                name="Produtos Pendentes"
                :has-active-filters="hasActiveFilters"
                :has-expanded-active-filters="hasExpandedActiveFilters"
                :filters="filters"
                :schema="tSchema(schema)"
                @expand-active-filters="hasExpandedActiveFilters = $event"
                @remove-filter="removeFilter"
                @refresh="refresh"
                @clear-filters="onClearFilters()"
                :showMessage="true"
                :messageUrl="'/api/orders/pending-products-alert'"
              >

             </filters-dialog>
            </div>
        </v-row>

        <v-row>
            <v-col cols="12">
                <pure-datatable endpoint="/api/orders/pending-products" :customSearch="customSearch" :queryParams="queryParams" :ready="ready" ref="datatable" @data-changed="onDataChanged" v-slot:default="{ vOn, vBind, updateOptions, isLoading }">
                    <div>
                        <portal v-if="!inDialog" to="v-form-base">
                            <v-form-base :model="filters" :schema="tSchema(schema)" @input="onFiltersChanged"> </v-form-base>
                        </portal>

                        <v-data-table id="pending_products"
                            class="elevation-1 d-flex flex-column justify-space-between no-extra-padding-data-table nowrap-headers"
                            :style="`border-radius: 16px; height: ${datatableSize}px;`"
                            fixed-header
                            multi-sort
                            :headers="tHeaders(headers)"
                            :hide-default-headers="isMobile"
                            :class="{mobile: isMobile}"
                            :items="displayProducts"
                            :item-class="getCampaignColor"
                            @update:options="refresh"
                            v-on="vOn"
                            v-bind="vBind"
                            hide-default-footer
                            disable-pagination
                            :no-data-text="$t('table.noData')"
                            :no-results-text="$t('table.noResults')"
                            :loading="isMobile?isLoading:false"
                            :loading-text="$t('table.loading')"
                            :footer-props="{
                                showFirstLastPage: false,
                                itemsPerPageOptions: itemsPerPageOptions,
                                itemsPerPageText: $t('table.itemsPerPage'),
                            }"
                            show-select
                            group-by="branch_order.document_id"
                            v-model="selectedRows"
                        >
                            <template #[`group.header`]="{ items, isOpen, toggle }">
                                <th colspan="100%">
                                    <v-icon @click="toggle">{{ isOpen ? 'mdi-minus' : 'mdi-plus' }} </v-icon>
                                    <span class="ml-1" style="cursor: pointer" @click="openOrderDetails(items[0].branch_order)">{{ items[0].branch_order.document_id }} &ndash; {{ formatDate(items[0].branch_order.document_date) }}</span>
                                </th>
                            </template>

                            <template #[`header.campaign`]>
                                <v-icon style="right: 10%">mdi-star-outline</v-icon>
                            </template>

                            <template v-if="!isMobile"  #[`item.code`]="scope">
                                <div class="d-flex justify-start align-center">
                                    <div style="cursor: pointer" @click="openProductDetails(scope.item.product)" data-cy="pending-product-code">
                                        {{ scope.item.code }}
                                    </div>
                                </div>
                            </template>

                            <template v-if="!isMobile" #[`item.designation`]="scope">
                                <div class="d-flex justify-start align-center" data-cy="designations">
                                    <div
                                        :class="{
                                            'pl-0': !scope.item.isIndented,
                                            'pl-11': scope.item.isIndented,
                                        }"
                                    >
                                    <div class="datatable-image" v-if="scope.item.product">
                                        <div class="image-product-list" :style="'background-image: url('+scope.item.product.thumbnail+');'"
                                        @click="openProductDetails(scope.item.product)">
                                        </div>
                                    </div>
                                    <div class="datatable-image" v-else>
                                        <div class="image-product-list" style="background-image: url(/storage/assets/no-image.jpg);">
                                        </div>
                                    </div>
                                        <!--<product-image
                                            :is-new="scope.item.product ? !!scope.item.product.new : false"
                                            :productCode="scope.item.product ? scope.item.product.invoice_code : ''"
                                            :imageSrc="scope.item.product ? scope.item.product.image : ''"
                                            width="35"
                                            height="35"
                                            max-width="35"
                                            max-height="35"
                                            style="cursor: pointer; position: relative"
                                            @click="openProductDetails(scope.item.product)"
                                        ></product-image>-->
                                    </div>

                                    <div class="pl-2 datatable-designation-text" style="cursor: pointer" @click="openProductDetails(scope.item.product)" data-cy="pending-product-designation">
                                        {{ scope.item.designation }}
                                    </div>
                                </div>
                            </template>

                            <template v-if="!isMobile" #[`item.product__has_current_stock`]="scope">
                                <div class="d-flex justify-center align-center" data-cy="stocks">
                                    <v-tooltip bottom open-on-hover content-class="myprovet-tooltip" data-cy="stocks">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon v-if="!scope.item.orderable" style="left: -15%" :color="isAvailable(scope.item) ? 'green' : 'red'" v-on="on" v-bind="attrs">mdi-circle</v-icon>
                                            <v-icon v-else style="left: -15%" color="blue" v-on="on" v-bind="attrs">mdi-circle</v-icon>
                                        </template>
                                        <span v-if="!scope.item.orderable">{{ isAvailable(scope.item) ? $t('orders.base.stockAvailable') : $t('orders.base.confirmStock') }}</span>
                                        <span v-else>{{ $t('orders.base.orderableConfirmStock') }}</span>
                                    </v-tooltip>
                                </div>
                            </template>

                            <template v-if="!isMobile"  #[`item.extraIcons`]="scope">
                                <product-additional-info v-if="scope.item.product" :product="scope.item.product"></product-additional-info>
                            </template>

                            <template v-if="!isMobile"  #[`item.pending_quantity`]="scope">
                                <div class="d-flex justify-center align-center">
                                    <div style="cursor: pointer" @click="openProductDetails(scope.item.product)">
                                        <template v-if="!scope.item.campaign_stamp || (scope.item.campaign_stamp && scope.item.discount1==0 && scope.item.pending_quantity>0 )">{{ scope.item.pending_quantity }}</template>
                                    </div>
                                </div>
                            </template>

                            <template v-if="!isMobile" #[`item.bonus`]="scope">
                                <div class="d-flex justify-center align-center">
                                    <div style="cursor: pointer" @click="openProductDetails(scope.item.product)">
                                        <div v-if="scope.item.discounted_price != 0 && (!scope.item.campaign_stamp || (scope.item.campaign_stamp && scope.item.discount1 == 0))"></div>
                                        <div v-else-if="scope.item.campaign_stamp && scope.item.discount1 > 0 && scope.item.discount1 != 100">{{ formatDecimal(scope.item.discount1) }} %</div>
                                        <div v-else>{{ scope.item.quantity }}</div>
                                    </div>
                                </div>
                            </template>

                            <template v-if="!isMobile" #[`item.campaign`]="scope">
                                <template v-if="userStore.hasPermissionTo('View campaigns') && !branchNoCampaigns">
                                    <campaign-tooltip v-if="hasBonus(scope.item)" isOutlined :text="$t('orders.pending.campaignBonus')"></campaign-tooltip>
                                    <campaign-tooltip v-else-if="scope.item.campaign_stamp" disabled :text="scope.item.campaign_desc ? scope.item.campaign_desc : $t('orders.pending.campaign')"></campaign-tooltip>
                                </template>
                            </template>

                            <template v-if="!isMobile"  #[`item.actions`]="scope">
                                <div class="d-flex justify-end align-center">
                                    <pending-product-comment class="ml-1" v-if="scope.item.product" :productObj="scope.item.product" :pendingProductsComments="pendingProductsComments"></pending-product-comment>
                                </div>
                            </template>
                            <template v-if="isMobile" v-slot:item="{ item, isSelected, select}">

                            <tr>

                                <v-card
                                    elevation="2"
                                    :class=" getCampaignColor(item)"
                                    >
                                    <v-row>
                                        <v-col class="d-flex flex-column col pt-0 pb-0 pl-0 pr-0">
                                            <v-row class="d-flex align-start pt-0 pb-0">

                                                <v-col  class="col col-3 pt-0 pb-0">
                                                    <div class="datatable-image" v-if="item.product">
                                                        <div class="image-product-list" :style="item.product!=null?'background-image: url('+item.product.thumbnail+');':'background-image: url(/storage/assets/no-image.jpg);'"
                                                        @click="openProductDetails(item.product)">
                                                        </div>
                                                    </div>
                                                    <div class="datatable-image" v-else>
                                                        <div class="image-product-list" style="background-image: url(/storage/assets/no-image.jpg);">
                                                        </div>
                                                    </div>
                                                </v-col>
                                                <v-col  class="col col-9 pt-0 pb-0">
                                                    <v-row class="d-flex align-start pt-0 pb-0">
                                                        <v-col class="col col-12 pt-0 pb-0">
                                                            <div class="pl-0 datatable-designation-text" style="cursor: pointer" @click="openProductDetails(item.product)">
                                                                {{ item.designation }}
                                                            </div>
                                                        </v-col>
                                                        <v-col  class="col col-12 pt-0 pb-0">
                                                            <div class="pl-0 datatable-lable-text laboratory">
                                                                {{ item.code}}
                                                            </div>
                                                        </v-col>
                                                        <v-col class="col col-12 pt-0 pb-0 stock">
                                                            <v-tooltip bottom open-on-hover content-class="myprovet-tooltip" data-cy="stocks">
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-icon v-if="!item.orderable" :color="isAvailable(item) ? 'green' : 'red'" v-on="on" v-bind="attrs">mdi-circle</v-icon>
                                                                    <v-icon v-else color="blue" v-on="on" v-bind="attrs">mdi-circle</v-icon>
                                                                </template>
                                                                <span v-if="!item.orderable">{{ isAvailable(item) ? $t('orders.base.stockAvailable') : $t('orders.base.confirmStock') }}</span>
                                                                <span v-else>{{ $t('orders.base.orderableConfirmStock') }}</span>
                                                            </v-tooltip>
                                                            <product-additional-info :product="item.product"> </product-additional-info>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                <v-col  class="col col-12 pt-0 pb-0">
                                                    <v-row class="d-flex align-start pt-0 pb-0">
                                                        <v-col class="col col-6 pt-0 pb-0">
                                                            <v-simple-checkbox class="seleted-item" :value="checkIfSelected(item)" @input="select($event)"></v-simple-checkbox>
                                                        </v-col>
                                                        <v-col class="col col-6 pt-0 pb-0">
                                                            <div class="d-flex justify-end align-center">
                                                                <template v-if="userStore.hasPermissionTo('View campaigns') && !branchNoCampaigns">
                                                                    <campaign-tooltip v-if="hasBonus(item)" isOutlined :text="$t('orders.pending.campaignBonus')"></campaign-tooltip>
                                                                    <campaign-tooltip v-else-if="item.campaign_stamp" disabled :text="item.campaign_desc ? item.campaign_desc : $t('orders.pending.campaign')"></campaign-tooltip>
                                                                </template>
                                                                <v-icon small class="appbar-icon-button-small btn-bg-color-blue dark-blue-color ml-1" style="cursor: pointer" @click="openProductDetails(item.product)" data-cy="product-details"> mdi-dots-horizontal-circle-outline </v-icon>
                                                                <pending-product-comment class="ml-1" v-if="item.product" :productObj="item.product" :pendingProductsComments="pendingProductsComments"></pending-product-comment>
                                                            </div>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                <v-col  class="col col-12 pt-0 pb-0 mt-2">
                                                    <v-row class="d-flex align-start pt-0 pb-0">
                                                        <v-col class="col col-6 pt-0 pb-0 pl-0">
                                                            <div class="col pt-0 pb-0 label">{{ $t('orders.base.quantity') }}</div>
                                                            <div class="label c" style="cursor: pointer" @click="openProductDetails(item.product)">
                                                                <template v-if="!item.campaign_stamp || (item.campaign_stamp && item.discount1 > 0 && item.discount1 != 100)">
                                                                    {{ item.pending_quantity }}
                                                                </template>
                                                                <template v-else>
                                                                    <div >-</div>
                                                                </template>
                                                            </div>
                                                        </v-col>
                                                        <v-col class="col col-6 pt-0 pb-0 pl-0">
                                                            <div class="col pt-0 pb-2  pl-0 pr-0 label lf "><div class="l-sub">{{ $t('orders.base.vat') }}</div><div class="l-sub-value">{{item.vat}} %</div></div>

                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                <v-col  class="col col-12 pt-0 pb-0">
                                                    <v-row class="d-flex align-start pt-0 pb-0">
                                                        <v-col class="col col-6 pt-0 pb-0 pl-0">
                                                            <div class="col pt-0 pb-0 label">{{ $t('orders.base.bonus') }}</div>
                                                            <div class="label c" style="cursor: pointer" @click="openProductDetails(item.product)">
                                                                <div v-if="item.discounted_price != 0 && (!item.campaign_stamp || (item.campaign_stamp && item.discount1 == 0))">-</div>
                                                                <div v-else-if="item.campaign_stamp && item.discount1 > 0 && item.discount1 != 100">{{ formatDecimal(item.discount1) }} %</div>
                                                                <div v-else v-html="item.quantity!=null?item.quantity:'-'">{{ item.quantity }}</div>
                                                            </div>
                                                        </v-col>
                                                        <v-col class="col col-6 pt-0 pb-0 pl-0">
                                                            <div class="col pt-0 pb-2  pl-0 pr-0 label lf "><div class="l-sub">{{ $t('orders.base.price') }}</div><div class="l-sub-value">
                                                                <template v-if="item.discount">
                                                                        <v-list-item-content class="py-0">
                                                                            <div class="flex-column" style="line-height: 18px">
                                                                                <p class="red--text text-decoration-strikethrough mb-0" style="font-size: 0.6rem">{{ formatPrice(item.price*item.quantity) }}</p>
                                                                                <v-list-item-subtitle class="green--text text--darken-2" style="font-size: 0.6rem">{{ formatPrice((item.price*item.quantity) - (item.price*item.quantity) * (item.discount / 100)) }}</v-list-item-subtitle>
                                                                            </div>
                                                                        </v-list-item-content>
                                                                    </template>

                                                                    <template v-else-if="item.value">
                                                                        <v-list-item-content class="py-0">
                                                                            <div class="flex-column" style="line-height: 18px">
                                                                                <p class="red--text text-decoration-strikethrough mb-0" style="font-size: 0.6rem">{{ formatPrice(item.price*item.quantity) }}</p>
                                                                                <v-list-item-subtitle class="green--text text--darken-2" style="font-size: 0.6rem">{{ formatPrice(item.value*item.quantity) }}</v-list-item-subtitle>
                                                                            </div>
                                                                        </v-list-item-content>
                                                                    </template>

                                                                    <template v-else>
                                                                        {{ formatPrice(item.price) }}
                                                                    </template>
                                                            </div>
                                                        </div>

                                                        </v-col>
                                                    </v-row>
                                                </v-col>

                                            </v-row>
                                        </v-col>
                                    </v-row>

                                </v-card>
                            </tr>

                            </template>

                            <template v-slot:footer="scope">
                                <div>
                                    <div class="datatable-footer-border"></div>

                                    <data-table-footer
                                        :showPagination="false"
                                        :showExport="canExport()"
                                        :scope="scope"
                                        @export="exportData"
                                        @updateOptions="updateOptions"
                                        :footerActionButtons="footerActionButtons"
                                        @on-try-remove-pending-product="tryRemovePendingProduct()"
                                        :showOrderButton="false"
                                        :isLoading="isLoading"
                                    >
                                    </data-table-footer>
                                </div>
                            </template>
                        </v-data-table>
                    </div>
                </pure-datatable>
            </v-col>
        </v-row>

        <app-dialog v-if="isProductDetailsDialogOpen" :isProductDetails="true" :value="isProductDetailsDialogOpen" @input="isProductDetailsDialogOpen = $event" :title="$t('orders.base.productSheet')" width="55vw" isResponsive :showActions="false">
            <template #content>
                <product-details :product="selectedProduct" :key="selectedProduct.id" @change-product="selectedProduct = $event"></product-details>
            </template>
        </app-dialog>

        <order-details-dialog v-if="isOrderDetailsDialogOpen" isPendingOrder :value="isOrderDetailsDialogOpen" :selectedOrder="selectedOrder" :detailsHeaders="details_headers" @onCancel="isOrderDetailsDialogOpen = false"></order-details-dialog>
        <alert-message-dialog :value="isSelectedRowsAlertDialogOpen" @on-cancel="isSelectedRowsAlertDialogOpen = false" :message="$t('orders.pending.noneSelected')"> </alert-message-dialog>
        <alert-message-dialog :value="isOrderableAlertDialogOpen" @on-cancel="closeOrderableAlertDialog()" :url="'/api/products/only-by-order-message'"> </alert-message-dialog>
        <confirmation-dialog :value="isConfirmDialogOpen" @onSuccess="removePendingProduct()" @onCancel="isConfirmDialogOpen = false" :title="$t('layout.attention')" :question="$t('orders.pending.confirmCancel')"> </confirmation-dialog>
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useUserStore } from '@/Stores/user';
import { useBranchStore } from '@/Stores/branch';
import { useCategoriesStore } from '@/Stores/categories';
import { useAppStore } from '@/Stores/app';
import { axios } from '@/Services/Backend';
import PureDatatable from '@arentia/atools/PureDatatable';
import VFormBase from 'vuetify-form-base';
import ResizeObserver from 'resize-observer-polyfill';

export default {
    components: {
        VFormBase,
        PureDatatable,
    },

    props: {
        model: [Object, Array],
        schema: [Object, Array],
        headers: [Object, Array],
        details_headers: [Object, Array],

        inDialog: {
            type: Boolean,
            default: false,
        },
    },

    data: () => ({
        isLoading: false,

        filters: {},
        queryParams: {},
        ready: false,
        hasExpandedActiveFilters: false,
        datatableSize: 200,
        resizeObserver: null,

        pendingProducts: [],
        selectedRows: [],
        selectedOrder: null,
        selectedProduct: null,
        productCampaigns: [],

        pendingProductsComments: [],

        orderableMessage: '<strong>Artigo por Encomenda</strong> - A sua anulação não é possível, por favor contacte o delegado comercial ou o SAC!',

        message: '',

        isOrderDetailsDialogOpen: false,
        isProductDetailsDialogOpen: false,
        isListCampaignDialogOpen: false,
        isSelectedRowsAlertDialogOpen: false,
        isOrderableAlertDialogOpen: false,
        isConfirmDialogOpen: false,

        footerActionButtons: [
            {
                text: 'Submeter Anulação',
                class: 'mt-1 myprovet-btn-ok',
                action: 'on-try-remove-pending-product',
            },
        ],
        itemsPerPageOptions:window.innerWidth>=768&&window.innerWidth<=1366?[20,50,100]:[10,20,50],
        customSearch: {
            designation: `{
                "type": "query-builder-group",
                "query": {
                    "logicalOperator": "any",
                    "children": [
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "code",
                                "operator": "contains",
                                "operand": "code",
                                "value": "__designation__"
                            }
                        },
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "product__ean",
                                "operator": "contains",
                                "operand": "product__ean",
                                "value": "__designation__"
                            }
                        },
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "product__invoice_code",
                                "operator": "contains",
                                "operand": "product__invoice_code",
                                "value": "__designation__"
                            }
                        },
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "designation",
                                "operator": "keywords",
                                "operand": "designation",
                                "value": "__designation__"
                            }
                        }
                    ]
                }
            }`,
        },
    }),

    created() {
        this.getMessage();
    },

    mounted() {
        this.prepareResponsiveBehaviour();

        window.EventBus.$on('on-save-pending-product-comment', (product) => {
            this.onSavePendingProductComment(product);
        });

        window.EventBus.$on('updated-product-stocks', ({ data }) => {
            this.pendingProducts.forEach((product) => {
                const productStock = data.find((p) => p.code == product.code);
                if (productStock && product.has_current_stock != productStock.has_current_stock) {
                    this.$set(product, 'has_current_stock', productStock.has_current_stock);
                }
            });
        });

        window.EventBus.$on('update:product-search', (e) => {
            //console.log('product-search',e)
            this.setSearchByCamera(e)
        })
        let portrait = window.matchMedia("(orientation: portrait)");
        portrait.addEventListener("change", (e)=> {
             // Do change
                 this.refreshDeely()
        })
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.computeDatatableSize);
        if (this.inDialog) {
            this.resizeObserver?.unobserve(this.$refs.dialogHeader);
        } else {
            this.resizeObserver?.unobserve(this.$refs.headerFilters);
        }
        window.EventBus.$off('on-save-pending-product-comment');
        window.EventBus.$off('update:product-search',null);
        window.EventBus.$off('updated-product-stocks');
    },

    watch: {
        'branchStore.branch': {
            handler: function (branch, oldBranch) {
                if (!branch) return;

                this.queryParams.branch_id = branch.id;

                // Reload the page if the old branch and the new one have different no_campaigns value.
                // Datatable should show or hide the has_campaign column.
                if (branch && oldBranch && branch.id != oldBranch.id && branch.no_campaigns != oldBranch.no_campaigns) location.reload();

                this.ready = true;
                this.$nextTick(() => this.refresh());
            },
            immediate: true,
        },
    },

    computed: {
        ...mapStores(useUserStore, useBranchStore, useCategoriesStore,useAppStore),

        hasActiveFilters() {
            return Object.values(this.filters)
                .filter((x) => x) // ignore null or undefined
                .some((x) => (typeof x === 'string' && x !== '') || (Array.isArray(x) && x.length > 0) || (typeof x === 'object' && Object.keys(x).length > 0));
        },

        displayProducts() {
            const seenCampaignColors = new Map();
            const colors = ['campaign-color-1', 'campaign-color-2'];
            let colorIndex = 0;

            return this.pendingProducts.map((product) => {
                if (!product.campaign_stamp) {
                    return product;
                }

                // Set the campaign color
                if (seenCampaignColors.has(product.campaign_stamp)) {
                    product.campaign_color = seenCampaignColors.get(product.campaign_stamp);
                } else {
                    product.campaign_color = colors[colorIndex++ % colors.length];
                    seenCampaignColors.set(product.campaign_stamp, product.campaign_color);
                }

                if (this.hasBonus(product)) {
                    const originatingStamps = product.campaign_originating_stamps.split(';');

                    const requirementsToDisplay = this.pendingProducts.filter((it) => it.campaign_stamp === product.campaign_stamp && originatingStamps.includes(it.phc_stamp) && !this.hasBonus(it));

                    product.isIndented = requirementsToDisplay.length === 1;
                }

                return product;
            });
        },

        branchNoCampaigns() {
            return this.branchStore.hideCampaigns;
        },
        isMobile(){
            if(this.appStore.is_mobile){
                this.footerActionButtons= [
                    {
                        text: 'Submeter',
                        class: 'mt-1 myprovet-btn-ok btn-submit-pending',
                        action: 'on-try-remove-pending-product',
                    },
                ]
            }
            return this.appStore.mobile_ls?false:this.appStore.is_mobile;
        }
    },

    methods: {
        setSearchByCamera(searchTerm){
            //this.$set(this.model, 'designation', searchTerm);
            this.$set(this.filters, 'designation', searchTerm);
            this.refresh()
        },
        checkIfSelected(item){
            //this.selectedRows.forEach((row) => {
           let rs = _.find(this.selectedRows,item,{id:item.id})
           //console.log('rs',rs);
           if(rs){
             return true
           }
           return false

        },
        setItemsPorPage(){
            this.itemsPerPageOptions=window.innerWidth>=768&&window.innerWidth<=1366?[20,50,100]:[10,20,50]
        },
        refreshDeely(){
            setTimeout(()=>{
                    this.refresh();
                },300)
        },
        canExport() {
            return this.userStore.hasPermissionTo('Export pending products');
        },

        exportData() {
            if (!this.branchStore.branch || !this.$refs.datatable) return;

            const axiosSettings = {
                url: '/api/orders/pending-products/export',
                params: {
                    branch_id: this.branchStore.branch.id,
                },
            };

            this.$refs.datatable.exportData(axiosSettings, 'export_produtos_pendentes');
        },

        prepareResponsiveBehaviour() {
            const makeResponsive = () => {
                this.computeDatatableSize();
            };

            this.resizeObserver = new ResizeObserver(makeResponsive);

            if (this.inDialog) {
                this.resizeObserver.observe(this.$refs.dialogHeader);
            } else {
                this.resizeObserver.observe(this.$refs.headerFilters);
            }

            window.addEventListener('resize', makeResponsive);

            makeResponsive();
        },

        computeDatatableSize() {
            const topElement = this.inDialog ? this.$refs.dialogHeader : this.$refs.headerFilters;

            if (topElement) {
                const value = this.inDialog ? 172 : 74;

                const topHeight = topElement.getBoundingClientRect().bottom;
                const res = window.innerHeight - value - topHeight;
                this.datatableSize = res;
            }
        },

        getCampaignColor(item) {
            if (!item.campaign_stamp) return;
            return item.campaign_color;
        },

        removeFilter(filters, index) {
            filters.splice(index, 1);

            this.onFiltersChanged();
        },

        onFiltersChanged() {
            let hasAutoSearch = this.userStore.user?.auto_search_disabled
            if(this.isIOS()){
                if(!hasAutoSearch){
                    this.setFiltersChanged();
                }
            }else{
                this.setFiltersChanged();
            }
        },
        setFiltersChanged(){
            this.refresh();
            window.EventBus.$emit('check-if-should-overflow');
            window.EventBus.$emit('check-if-should-underflow');
        },
        applyDefaultFilters() {
            for (let field in this.model) {
                this.$set(this.filters, field, this.model[field]);
            }
        },

        clearNormalFilters() {
            this.applyDefaultFilters();
            this.refresh();
        },

        onClearFilters() {
            this.clearNormalFilters();
        },

        refresh(options) {
            if (!this.branchStore.branch) return;

            // The filters have changed, so we'll reset the selected rows to prevent hidden selections.
            this.selectedRows.splice(0, this.selectedRows.length);

            if (this.$refs.datatable) {
                if (options) {
                    this.$refs.datatable.setLocalOptions(options);
                }else{
                    options=this.$refs.datatable.localOptions
                    options.itemsPerPage=window.innerWidth>=768&&window.innerWidth<=1366?20:10
                    this.$refs.datatable.setLocalOptions(options);
                }

                this.$refs.datatable.onChangeQueryBuilder(this.filters, this.schema);
            }
        },

        isAvailable(product) {
            return product !== null ? product.has_current_stock : false;
        },

        openOrderDetails(order) {
            this.selectedOrder = order;
            this.isOrderDetailsDialogOpen = true;
        },

        openProductDetails(product) {
            if (!product) {
                this.showError(this.$t('orders.pending.sheetUnavailable'));
                return;
            }

            this.selectedProduct = product;
            this.isProductDetailsDialogOpen = true;
        },

        onSavePendingProductComment(product) {
            const item = this.getProductComment(product);
            if (item) this.pendingProductsComments.splice(this.pendingProductsComments.indexOf(item), 1);

            this.pendingProductsComments.push(product);
        },

        getProductComment(product) {
            const item = this.pendingProductsComments.find((item) => item.id === product.id);
            return item !== undefined ? item : null;
        },

        tryRemovePendingProduct() {
            if (this.selectedRows.length === 0) {
                this.isSelectedRowsAlertDialogOpen = true;
                return;
            }

            // @Note: Check if any selected row is orderable
            this.selectedRows.forEach((row) => {
                if (row.product !== null && this.isOrderable(row.product)) {
                    this.isOrderableAlertDialogOpen = true;
                    return;
                }
            });

            if (!this.isOrderableAlertDialogOpen) this.isConfirmDialogOpen = true;
        },

        closeOrderableAlertDialog() {
            this.isOrderableAlertDialogOpen = false;
            this.isConfirmDialogOpen = true;
        },

        isOrderable(product) {
            return product.orderable > 0;
        },

        removePendingProduct() {
            this.isConfirmDialogOpen = false;
            this.isLoading = true;

            axios
                .post('/api/orders/cancel-pending-products', {
                    branch_id: this.branchStore.branch.id,
                    products: this.selectedRows,
                })
                .then(({ data }) => {
                    if (data.messages?.length) {
                        data.messages.forEach((message) => this.showError(message, 7000));
                        this.refresh();
                        return;
                    }

                    this.showSuccess(this.$t('orders.pending.cancelled'));
                    this.refresh();
                })
                .catch((error) => {
                    console.error(error);
                    this.showError(this.$t('orders.pending.cancelError'));
                })
                .finally(() => (this.isLoading = false));
        },

        getMessage() {
            axios
                .get('/api/orders/pending-products-alert')
                .then((response) => {
                    this.message = response.data;
                })
                .catch((error) => {
                    console.log(error);
                    this.showError(this.$t('orders.pending.alertLoadError'));
                });
        },

        hasBonus(branch_order_line) {
            return branch_order_line.campaign_originating_stamps && branch_order_line.discounted_price == 0 && branch_order_line.pending_quantity > 0;
        },

        onDataChanged(value) {
            // Update the local data so that we can display the campaigns.
            this.$set(this, 'pendingProducts', value?.data ?? []);

            const wrapper = this.$refs['datatable']?.$el?.querySelector('div.v-data-table__wrapper');
            this.scrollDatatableToTop(this.$vuetify, wrapper);
        },
    },
};
</script>
<style>
 #pending_products .datatable-image .image-product-list{
     margin-top:7px;
 }
</style>
